// extracted by mini-css-extract-plugin
module.exports = {"filter_panel":"FilterPanel_filter_panel__GllLU"};